import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import "@purple-dot/design-system/global-style.css";
import { theme as PDTheme } from "@purple-dot/design-system/theme";
import { ExtraErrorData } from "@sentry/integrations";
import * as Sentry from "@sentry/react";
import App from "next/app";
import React from "react";
import { ConfigContext } from "../components/common/config-context";
import "../public/nprogress.css";
import "../public/reboot.css";
import { createGenerateClassName, createTheme, jssPreset, ThemeProvider as MuiThemeProvider, StylesProvider } from "@material-ui/core/styles";
import { create, SheetsRegistry } from "jss";
import { ThemeProvider } from "styled-components";
function createPageContext() {
    var jss = create(_object_spread({}, jssPreset()));
    var generateClassName = createGenerateClassName({
        disableGlobal: true
    });
    var baseTheme = createTheme();
    var theme = _object_spread({}, baseTheme, PDTheme);
    return {
        jss: jss,
        generateClassName: generateClassName,
        sheetsRegistry: new SheetsRegistry(),
        theme: theme
    };
}
function PurpleDotApp(param) {
    var Component = param.Component, pageProps = param.pageProps, configProps = param.configProps;
    if (configProps === null || configProps === void 0 ? void 0 : configProps.sentryDSN) {
        Sentry.init({
            dsn: configProps.sentryDSN,
            environment: configProps.appEnv,
            release: configProps.appRelease,
            autoSessionTracking: false,
            integrations: [
                new ExtraErrorData({
                    depth: 10
                })
            ],
            denyUrls: [
                /extensions\//i,
                /^chrome:\/\//i,
                /^chrome-extension:\/\//i
            ]
        });
    }
    var context = createPageContext();
    return /*#__PURE__*/ _jsx(Sentry.ErrorBoundary, {
        children: /*#__PURE__*/ _jsx(StylesProvider, {
            jss: context.jss,
            generateClassName: context.generateClassName,
            children: /*#__PURE__*/ _jsx(MuiThemeProvider, {
                theme: context.theme,
                children: /*#__PURE__*/ _jsx(ThemeProvider, {
                    theme: context.theme,
                    children: /*#__PURE__*/ _jsx(ConfigContext.Provider, {
                        value: {
                            googleClientId: configProps === null || configProps === void 0 ? void 0 : configProps.googleClientId,
                            host: configProps === null || configProps === void 0 ? void 0 : configProps.host
                        },
                        children: /*#__PURE__*/ _jsx(Component, _object_spread({}, pageProps))
                    })
                })
            })
        })
    });
}
PurpleDotApp.getInitialProps = function() {
    var _ref = _async_to_generator(function(context) {
        var ctx;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        App.getInitialProps(context)
                    ];
                case 1:
                    ctx = _state.sent();
                    return [
                        2,
                        _object_spread_props(_object_spread({}, ctx), {
                            configProps: context.ctx.req ? context.ctx.req.clientSideConfig : undefined,
                            pageContext: createPageContext()
                        })
                    ];
            }
        });
    });
    return function(context) {
        return _ref.apply(this, arguments);
    };
}();
export default PurpleDotApp;
